<script setup></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5L19 19" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5 19L19 5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped lang="scss"></style>
